import React, { Component } from "react";
import { Api } from "../../utils/api";

import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { UserForm } from "../forms/user.form";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { UserViewComponent } from "./user_view.component";
import { UserShow } from "./user_show.component";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";

export class CreateUserDialog extends Component {
  state = {
    name: "",
    email: "",
    phone: "",
    phone_area_code: 351,
    phone_alt: "",
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  constructor() {
    super();
    this.api = new Api();
  }

  componentDidMount() {
    const { name, email, phone, phone_alt, phone_area_code } =
      this.props.userInfo;
    this.setState({
      name,
      email,
      phone,
      phone_alt,
      phone_area_code: phone_area_code || 351,
    });
  }

  createUser = () => {
    if (
      !this.state.name ||
      !this.state.email ||
      !this.state.phone ||
      !this.state.phone_area_code
    )
      return;
    //
    if (this.props.userInfo && this.props.userInfo.user_id)
      this.api
        .patch(`/users/${this.props.userInfo.user_id}`, this.state)
        .then(({ data: user }) => {
          this.props.closeModal();
          setTimeout(() => window.location.reload(), 2000); //refresh page after 2s
          return this.props.setUser(user.user_id);
        });
    else
      this.api.post("/users", this.state).then(({ data: user }) => {
        this.props.closeModal();
        return this.props.setUser(user.id);
      });
  };

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Novo Utilizador</DialogTitle>
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item md={6}>
              <TextField
                name="name"
                label="Nome"
                margin="normal"
                InputLabelProps={{
                  shrink: !!this.state.name,
                }}
                variant="outlined"
                value={this.state.name}
                onChange={this.handleInputChange}
                fullWidth
                required
                helperText={"Obrigatório"}
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                name="email"
                label="Email"
                margin="normal"
                InputLabelProps={{
                  shrink: !!this.state.email,
                }}
                variant="outlined"
                value={this.state.email}
                onChange={this.handleInputChange}
                fullWidth
                required
                helperText={"Obrigatório"}
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                name="phone"
                label="Telefone"
                margin="normal"
                type="number"
                InputLabelProps={{
                  shrink: !!this.state.phone,
                }}
                variant="outlined"
                value={this.state.phone}
                onChange={this.handleInputChange}
                fullWidth
                required
                helperText={"Obrigatório"}
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                name="phone_area_code"
                label="Indicativo"
                margin="normal"
                type="number"
                variant="outlined"
                value={this.state.phone_area_code}
                onChange={this.handleInputChange}
                fullWidth
                required
                helperText={"Obrigatório"}
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                name="phone_alt"
                label="Telefone Alternativo"
                margin="normal"
                type="number"
                InputLabelProps={{
                  shrink: !!this.state.phone_alt,
                }}
                variant="outlined"
                value={this.state.phone_alt}
                onChange={this.handleInputChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.closeModal} color="primary">
            Cancel
          </Button>
          <Button
            disabled={
              this.state.name === null ||
              this.state.name === "" ||
              this.state.email === null ||
              this.state.email === "" ||
              this.state.phone === null ||
              this.state.phone === "" ||
              this.state.phone_area_code === null ||
              this.state.phone_area_code === ""
                ? true
                : false
            }
            onClick={this.createUser}
            color="primary"
          >
            {this.props.userInfo.user_id ? "Atualizar" : "Criar"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export class UserCard extends Component {
  state = {
    createUser: false,
  };

  constructor() {
    super();
    this.api = new Api();
    this.form = React.createRef();
    this.submit = this.submit.bind(this);
    this.isSubmitting = this.isSubmitting.bind(this);
    this.setForm = this.setForm.bind(this);
  }

  submit() {
    if (this.form) {
      this.form.submitForm();
    }
  }

  setForm(val) {
    this.form = val;
  }

  isSubmitting() {
    return this.form ? this.form.isSubmitting : false;
  }

  openNewUserModal = () => {
    this.setState({ createUser: true });
  };

  closeNewUserModal = () => {
    this.setState({ createUser: false });
  };

  setUser = (user_id) => {
    this.props.handleSubmit({ user_id });
  };

  // when user_id on user_requests === null
  render() {
    const { user } = this.props;
    const { user_id } = user;
    const user_valid = (user.name && user.email && user.phone) || user_id;
    return (
      <>
        <CreateUserDialog
          userInfo={user}
          isOpen={this.state.createUser}
          closeModal={this.closeNewUserModal}
          setUser={this.setUser}
        />
        <Typography gutterBottom className="issuing-title" color="#AD083E">
          Dados do Pedido
        </Typography>
        <ExpansionPanel square className={!user_valid && "alert-missing"}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            {!user_valid && (
              <Grid>
                <Typography className="alert-missing-text" variant="body2">
                  Por favor complete os dados do Pedido
                </Typography>
              </Grid>
            )}
            {user_valid && (
              <>
                {user_id && <UserViewComponent userId={user_id} />}
                {!user_id && <UserShow {...user} />}
              </>
            )}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container>
              <Grid item md={6}>
                <UserForm
                  getForm={this.setForm}
                  onSubmit={this.props.handleSubmit}
                  {...this.props.user}
                />
              </Grid>
              <Grid item md={6}>
                <Grid container alignItems="center" style={{ height: "100%" }}>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openNewUserModal}
                  >
                    {user_id ? "Atualizar utilizador" : "Novo utilizador"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions>
            <Button
              size="small"
              color="primary"
              disabled={this.isSubmitting()}
              onClick={this.submit}
            >
              Save
            </Button>
          </ExpansionPanelActions>
        </ExpansionPanel>
      </>
    );
  }
}
